<template>
  <div class="checkInEdit full-height">
    <ld-header>
      订单信息填写
    </ld-header>

    <div class="tkEditwrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div>
          <div class="box">
            <van-field
              label="航班号"
              readonly
              v-model="params.flightNo"
            />
            <van-field
              label="选座类型"
              readonly
              v-model="params.seatType"
            />
          </div>
          <!--出行人 -->
          <traver
            class="box"
            :traveler-list="travelerList"
            :title="$t('C001','乘机人')"
            cplx="10916"
            element=".checkInEdit"
          />

          <trip-type
            is-switch
            :switch-title="tripType==1?'本次预订为因公预订':'本次预订为因私预订'"
            class="box"
          />

          <!-- 差旅信息 -->
          <travel-info
            class="box"
            v-show="tripType==1"
            ref="travelinfo"
            @selected="getTavelInfo"
            element=".checkInEdit"
          />

          <!-- 联系信息 -->
          <van-field
            :label="$t('D022','联系信息')"
            :readonly="true"
            @click="$refs['linker'].toggle()"
          >
            <div slot="input">
              {{ linker.linkMan }} ({{ linker.linkTel || linker.linkMobile }})

              <div class="font12 gray">
                {{ $t('D020','邮箱') }} ({{ linker.linkEmail }})
              </div>
            </div>
          </van-field>
        </div>
      </mescroll-vue>
    </div>

    <!-- 编辑联系人 -->
    <ld-edit-linker
      ref="linker"
      :data="linker"
      @selected="getLinker"
    />

    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        type="flex"
        align="center"
        justify="space-between"
        class="bg-white full-width shadow"
      >
        <van-col span="1" />
        <van-col span="7">
          <span class="font12 money-color">&yen;</span>
          <span class="font22 money-color">{{ (searchInfo.salesPrice+searchInfo.serviceFee)* travelerList.length }}</span>
          <span class="font10 gray">&nbsp; {{ $t('E017','共') }}{{ travelerList.length }}人</span>
        </van-col>
        <van-col span="8">
          <!-- <div
            class="font12 text-left"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006','明细') }}</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </div> -->
        </van-col>
        <van-col
          span="8"
          class="pad-r-8"
        >
          <ld-button
            :loading="false"
            size="md"
            main
            @click.native="book"
          >
            {{ $t('F560','提交订单') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
  </div>
</template>

<script>
import { Cell, Tag, Popup, Field } from 'vant'
import { mapGetters } from 'vuex'
import ldEditLinker from 'Components/ldEditLinker'
import MescrollVue from 'mescroll.js/mescroll.vue'

import ldHeader from 'Common/ldHeader'
import travelInfo from 'Components/travelInfo'
import traver from 'Components/tk/traver'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import tripType from 'Common/tripType'
import ldButton from 'Common/ldButton'
import { getName, getIdType, getIdNumber } from 'Utils/publicFun'


export default {
  name: 'CheckInEdit',
  components: {
    ldHeader,
    travelInfo,
    [Cell.name]:Cell,
    [Tag.name]:Tag,
    [Popup.name]:Popup,
    [Field.name]:Field,
    traver,
    ldTabbar,
    ldButton,
    ldEditLinker,
    MescrollVue,
    tripType
  },
  data() {
    return {
      down:{use:false},
      showPlanes: false,
      showPrice: false,
      showReserved:false,
      priceList: [],
      changeRule: {},
      travelInfo:{},
      linker:{
        linkMan:'',
        linkTel:'',
        linkEmail:''
      },//联系人信息
      bxPrice:0,
      reservedData:[],
    }
  },
  computed: {
    ...mapGetters({
      searchInfo: 'checkIn/searchInfo',
      travelerList: 'checkIn/travelerList',
      flightInfo: 'checkIn/flightInfo',
      params: 'checkIn/params',
      tripType: 'tripType',
      userInfo:'userInfo',
      sysType:'sysType'
    }),
  },
  created() {
    this.linker={
      linkEmail:this.userInfo.empInfo.email,
      linkMan:this.userInfo.empInfo.empName,
      linkTel:this.userInfo.empInfo.phoneNumber
    }
  },
  methods: {
    getTavelInfo(info) {// 获取差旅信息
      let obj={
        'projectId': '',
        'projectCode': '',
        'projectName': '',
        'ccsqdId': '',
        'ccsqdNo': '',
        'routeId': '',
        'costCenterId': '',
        'costCenterCode': '',
        'costCenterName': '',
        'violateitemCode': '',
        'violateitem': '',
        'reasonCode': '',
        'reasonDesc': '',
        'corpId': '',
        'corpCode': '',
        'corpName': '',
        'tripType': '',
        'ccsqdRemark': '',
        'subjectCode': '',
        'ifSameOrder': ''
      }
      for(let k in obj){
        if(info[k]){
          obj[k]=info[k]
        }
      }
      this.travelInfo=obj
    },
    book(){
      if(this.travelerList.length==0){
        this.$toast('请选择乘机人！')
        return
      }
      if(!this.linker.linkTel){
        this.$toast('联系人手机号不能为空！')
        return
      }
      if(this.tripType==1){
        let bl=this.$refs.travelinfo.result()//判断差旅信息是否填写完整
        if(bl==false){
          return
        }
      }
      let psgList = this.travelerList.map((item,index) => {
        return {
          psgName: getName(item),
          psgType: item.psgType||'1',
          cardType: getIdType(item),//证件类型
          idNo: getIdNumber(item),//证件号码
          phoneNumber: item.phoneNumber,
          empId: item.conempId || item.empId
        }
      })
      this.$api['airService/bookOrder']({
        orderType:'11030',
        setOutModel:this.params.international==0?3:1,
        productId:this.searchInfo.id,
        seatType:this.params.seatType,
        personTime :this.travelerList.length,//人次
        //flightDate:this.params.departDate,
        flightDate:this.params.departDate.split(' ')[0],// 解决日期格式不正确的问题
        flightNo :this.params.flightNo ,
        deptCity  :this.flightInfo.departAirport,
        deptCityName:this.flightInfo.departCityName,
        arrCity :this.flightInfo.arriveAirport,
        arrCityName :this.flightInfo.arriveCityName,
        'psgBeanList': psgList,
        serverTime:'',
        serverType :'',
        serverAirportCode:this.params.serverAirportCode,
        serverAirportName:this.params.serverAirportName,
        linkman :this.linker.linkMan,
        linkMobile:this.linker.linkTel ,
        linkEmail:this.linker.linkEmail ,
        tripType:this.tripType,
        'travelInfo' :this.travelInfo,
        orderFrom :this.sysType,
        relateOrder :this.params.relateOrder,//关联单号
        flightTime:this.params.departDate.split(' ')[1],
        flightToDate:this.params.departDate.split(' ')[0],
        flightToTime:this.flightInfo.arriveTimes||this.flightInfo.arriveTime,
        airlineName:this.flightInfo.airlineName,
        airlineImg:this.flightInfo.airlineImg,
        terminal:this.flightInfo.departTerminal,
        toTerminal:this.flightInfo.arriveTerminal,
        toAirportCode:this.flightInfo.arriveAirport,
        toAirportName:this.flightInfo.arriveAirportName,
      }).then(res=>{
        let cache=res.data||{}
        this.$router.push({path:'/checkIn/order',query: { orderId:cache.orderId}})
      })
    },
    getLinker(info) {//修改联系人回调
      this.linker = {}
      this.linker = info
    },
  },
  filters:{
    productType:function(type){
      var obj={'0':'特价','1':'','2':'电商','3':'协议','6':'商务优享'}//1标准
      return obj[type]||''
    }
  },
  watch:{
  }
}

</script>

<style lang="less" scoped>
    @import '~Assets/styles/business';
    .pad-r-8{
        padding-right:8px;
    }
    .pad-lr-16{
        padding-left: 16px;
        padding-right: 16px;
    }
    .pad-b-20{
        padding-bottom:20px;
    }
    .box {
        padding-bottom: 5px;
    }
    .tkEditwrapper {
        height: calc(100vh - 96px);
        overflow: hidden;
    }
    .checkInEdit {
        .text-indent{
            text-indent: 20px;
        }
    }
</style>
